import { connect, ConnectedProps } from 'react-redux'

import AccordionHeader from 'components/accordion/AccordionHeader'
import { RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { searchType: RootState['search']['searchType'], flavour: RootState['layout']['flavour'] } => ({
  searchType: state.search.searchType,
  flavour: state.layout.flavour
})

const connector = connect(mapStateToProps, null)

export type AccordionHeaderContainerProps = ConnectedProps<typeof connector>

export default connector(AccordionHeader)
